import {
  COLOR4,
  COLOR1,
  WHITE,
  RADIO_COLOR,
  COLOR5,
  FONT_BOLD_16_18,
  COLOR2,
} from '../../constants';

export const SaveAppContactInfoStyles = {
  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '25px',
      color: 'rgba(143, 155, 179, 0.5)',
      width: '228px',
      height: '48px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
  },
  mainContainer: {
    position: 'relative',
    paddingRight: '20px',
  },
  snackbarRoot: {
    width: '100%',
    height: '70px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width: 1310px)': {
      height: 'auto',
    },
    '@media (max-width: 600px)': {
      left: 'unset',
      right: 'unset',
    },
  },
  snackBarBtn: {
    padding: '0px',
    color: '#4F4F4F',
  },
  snackbarStyleViaContentProps: {
    color: '#D71721',
    borderRadius: '6px',
    border: '2px solid #D71721',
    backgroundColor: '#FFF2F2',
    width: '100%',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '120%',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    minWidth: 'unset',
  },
  message: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '&.MuiSnackbarContent-message': {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  dd: {
    '&.MuiSnackbarContent-message': {
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  card_content: {
    textAlign: 'center',
    padding: '0px !important',
  },
  editIcon: {
    paddingBottom: '5px',
    textTransform: 'none',
  },
  saveAndExit: {
    font: 'normal 700 16px/18px Arial',
    width: '170px',
    height: '45px',
    margin: '0 15px 0 0',
    textTransform: 'none',
    borderRadius: '56px',
    '@media (max-width: 600px)': {
      width: '90%',
      marginBottom: '20px',
    },
  },
  backdrop: {
    zIndex: '1',
    color: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
    overflowY: 'scroll',
  },
  root: {
    alignItems: 'center',
    maxWidth: '779px',
    boxShadow: '0px 4px 12px rgba(62, 64, 70, 0.08)',
    borderRadius: '10px',
    '@media (max-width: 400px)': {
      maxHeight: 'unset',
    },
  },
  textTitle: {
    font: 'normal 700 32px/38px Arial',
    letterSpacing: '0.12px',
    marginLeft: '26px',
    marginRight: '26px',
    '@media (max-width: 560px)': {
      marginLeft: '0px',
      marginRight: '0px',
    },
  },
  textTitlee: {
    marginTop: '15px',
    '@media (max-width: 960px)': {
      marginTop: '10px',
    },
  },
  subTitle: {
    marginTop: '5px',
    '@media (max-width: 960px)': {
      marginTop: '3px',
    },
  },
  textTitleFirstName: {
    font: 'normal 700 32px/38px Arial',

    letterSpacing: '0.12px',
    marginTop: '42px',
    marginLeft: '8px',
    marginRight: '26px',
    '@media (max-width: 400px)': {
      marginLeft: '5px',
      marginRight: '8px',
    },
  },
  verify_details: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal 700 24px/28px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,

    '@media (max-width: 600px)': {
      font: 'normal 700 24px/28px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      margin: '0',
      marginBottom: '5px',
      marginTop: 0,
    },
  },
  verify_info: {
    font: 'normal normal 700 16px/100% TTNORMSPROBOLD',
    letterSpacing: '0px',
    textAlign: 'left',
    opacity: 1,
  },
  margin_adjust_for_top_grid: {
    marginTop: '21px',
    '@media (max-width: 960px)': {
      marginTop: '20px',
    },
  },
  gridStyles: {
    paddingRight: '20px',
    marginBottom: '20px',
    textAlign: 'left',
    '@media (max-width: 960px)': {
      paddingRight: '0px',
    },
  },
  contact_container: {
    padding: '20px 0px 0px 20px',
    '@media (max-width: 960px)': {
      padding: '20px 25px',
    },
    '@media (max-width: 600px)': {
      padding: '20px',
    },
  },
  contact_disclaimer: {
    font: 'normal normal 400 16px/18px Arial',
    opacity: 1,
    letterSpacing: '0.1px',
    padding: '5px 9px 0px 0px',
    textAlign: 'left',
  },
  tooltipmsg: {
    marginBottom: '15px',
  },
  back_button: {
    borderRadius: '25px',
    width: '170px',
    height: '45px',
    margin: '0px 20px 0px 0px',
    font: FONT_BOLD_16_18,
    textTransform: 'none',

    '@media (max-width: 600px)': {
      width: '90%',
      marginBottom: '20px',
    },
  },
  closeStyle: {
    margin: '15px',
  },
  backContinue: {
    width: '100%',
    margin: '30px 0',
    '@media (max-width: 900px)': {
      margin: '10px 0 30px 0',
    },
    '@media (max-width: 600px)': {
      margin: '20px',
    },
  },
  saveImg: {
    top: '9px',
  },
  textTwoStyle: {
    font: 'normal 400 16px/18px Arial',
    color: COLOR1,
    letterSpacing: '0.1px',
    marginTop: '20px',
    marginLeft: '26px',
    marginRight: '26px',
  },
  inviTwoStyle: {
    font: 'normal 400 16px/18px Arial',
    color: COLOR1,
    letterSpacing: '0.1px',
    marginTop: '42px',
    marginLeft: '26px',
    marginRight: '26px',
  },
  textTwoStyleKockOff: {
    font: 'normal normal normal 14px/17px Arial',
    color: COLOR1,
    letterSpacing: '0.1px',
    margin: '10px 25px 25px 25px',
  },
  close_icon: {
    width: '34px',
    height: '34px',
    cursor: 'pointer',
    margin: '5px 5px 0 0',
  },
  modal_close: {
    color: RADIO_COLOR,
    textAlign: 'right',
    height: '35px',
  },
  closeOverlay: {
    padding: '30px 30px 0px 0px',
    color: COLOR4,
    width: '44px',
    cursor: 'pointer',
    height: '28px',
    position: 'absolute',
  },
  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    textAlign: 'left',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },
  personal_button_container: {
    '@media (max-width: 650px)': {
      justifyContent: 'center',
      display: 'flex',
    },
  },
};
